






















import Vue from 'vue';

// Services
import AonContext from '~/services/AonContext';
import AnalyticsService from '~/services/AnalyticService';

export default Vue.extend({
    name: 'AssessmentButton',
    props: {
        isLoading: Boolean,
        premium: Boolean,
        context: {
            type: Object as () => AonContext,
            default: () => ({} as AonContext),
        },
        outline: Boolean,
    },
    data() {
        return {
            hasSlot: false as Boolean,
        };
    },
    computed: {
        premiumPrice(): Number {
            // @ts-ignore
            return this.$interfaces.assessmentModule.getAonProductPrice();
        },
        hasPremium(): boolean {
            return Boolean(this.context && this.context.hasPremium);
        },
        hasConsented(): boolean {
            return Boolean(this.context && this.context.hasConsented);
        },
    },
    methods: {
        onOpen() {
            if (this.$listeners['click']) {
                this.$emit('click');
                return;
            }

            AnalyticsService.assessmentActionClick(this.premium, this.hasPremium, false);
            if (this.premium) {
                this.context.openPremium();
            } else {
                this.context.openFreemium();
            }
        },
        hasDefaultSlot(): Boolean {
            return Boolean(this.$slots.default && this.$slots.default.length > 0);
        },
    },
    created() {
        this.hasSlot = this.hasDefaultSlot();
    },
    beforeUpdate() {
        this.hasSlot = this.hasDefaultSlot();
    },
});
